<template>
  <section class="account-wallet-details">
    <Heading class="account-wallet-details__title" :level="5">
      Detalhes da carteira
    </Heading>

    <div class="account-wallet-details__row-group">
      <Row :has-line="false">
        <template #top-left>
          <BaseText>{{ walletDetails.name }}</BaseText>
        </template>

        <template #bottom-left>
          <BaseText size="sm" :color="NebraskaColors.textSecondary">
            Nome
          </BaseText>
        </template>
      </Row>

      <Row>
        <template #top-left>
          <BaseText>{{ walletDetails.totalGrossWorth }}</BaseText>
        </template>

        <template #bottom-left>
          <BaseText size="sm" :color="NebraskaColors.textSecondary">
            Saldo atual da carteira
          </BaseText>
        </template>
      </Row>

      <Row>
        <template #top-left>
          <BaseText>
            {{ walletDetails.minimumDeposit.minimumValueToDeposit }}
          </BaseText>
        </template>

        <template #bottom-left>
          <BaseText size="sm" :color="NebraskaColors.textSecondary">
            Movimentação mínima
          </BaseText>
        </template>
      </Row>
    </div>
  </section>
</template>
<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { Heading, BaseText, Row } from '@warrenbrasil/nebraska-web';
import { IWalletDetails } from '@/modules/transaction/views/InvestmentTransaction/types';

@Component({
  name: 'AccountWalletDetails',
  components: { Heading, BaseText, Row }
})
export default class AccountWalletDetails extends Vue {
  @Prop({ type: Object, required: true })
  private walletDetails!: IWalletDetails;

  private NebraskaColors = NebraskaColors;
}
</script>

<style lang="less" scoped>
.account-wallet-details {
  display: flex;
  flex-direction: column;
  height: 100%;

  &__title {
    text-transform: uppercase;
    margin-bottom: @size-spacing-x350;
  }

  &__row-group {
    border-bottom: 1px solid @divider-primary;
  }

  &__disclaimer {
    margin: @size-spacing-x600 0;
  }

  @media (min-width: 59.375em) /* 950px */ {
    &__title {
      margin-bottom: @size-spacing-x300;
    }

    &__row-group > * {
      background: transparent;
    }

    &__disclaimer {
      margin: @size-spacing-x400 0 0;
    }
  }
}
</style>
